package com.essntl.core.stripe.di

import com.essntl.core.stripe.data.StripeClientImpl
import com.essntl.core.stripe.domain.StripeClient
import org.koin.dsl.module

val stripeModule
    get() =
        module {
            single<StripeClient> { StripeClientImpl(get()) }
        }
